// removed by extract-text-webpack-plugin
module.exports = {"menu":"src-templates----post-module---menu---3go1B","blogPost":"src-templates----post-module---blogPost---Wg4nK","title":"src-templates----post-module---title---_4a8P","content":"src-templates----post-module---content---2Opks"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/post.module.css
// module id = 360
// module chunks = 195351340454287